import parsePhoneNumber from 'libphonenumber-js';

export function formatPhoneNumberIntl(input: string): string {
    if (!input || input === '+') {
        return input;
    }

    try {
        const cleanInput = input.replace(/[^+\d]/g, '');
        
        if (cleanInput.length < 4) {
            return input;
        }

        const phoneNumber = parsePhoneNumber(cleanInput);
        if (phoneNumber) {
            const countryCode = `+${phoneNumber.countryCallingCode}`;
            const national = phoneNumber.nationalNumber;

            if (national.length >= 3) {
                const part1 = national.slice(0, 3);
                const part2 = national.length >= 6 ? national.slice(3, 6) : national.slice(3);
                const part3 = national.length > 6 ? national.slice(6) : '';

                return `${countryCode} ${part1}${part2 ? '-' + part2 : ''}${part3 ? '-' + part3 : ''}`;
            }
        }
    } catch (error) {
        console.error(error);
    }

    return input;
}